import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("ramirez_lang") || "en";
  });

  const setLanguage = useCallback((next) => {
    setLang(next);
    try {
      localStorage.setItem("ramirez_lang", next);
    } catch (_e) {
      /* ignore */
    }
  }, []);

  const t = useCallback(
    (path) => {
      const dict = translations[lang] || translations.en;
      const parts = path.split(".");
      let cur = dict;
      for (const p of parts) {
        if (cur && Object.prototype.hasOwnProperty.call(cur, p)) {
          cur = cur[p];
        } else {
          // fallback to english
          let fb = translations.en;
          for (const fp of parts) {
            if (fb && Object.prototype.hasOwnProperty.call(fb, fp)) fb = fb[fp];
            else return path;
          }
          return fb;
        }
      }
      return cur;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLanguage, t }), [lang, setLanguage, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
